// extracted by mini-css-extract-plugin
module.exports = {"loaderWrapper":"UpsellProducts_loaderWrapper__1PkbZ","errorMessage":"UpsellProducts_errorMessage__2nXC8"};